// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_pKB","cls2":"LoswpTabsHero-cls2_geB LoswpTabsHero-cls1_pKB"};